/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Relationship request details
 * @export
 * @interface CreateTenantRelationshipRequest
 */
export interface CreateTenantRelationshipRequest {
    /**
     * Target tenant ID (the tenant being accessed)
     * @type {string}
     * @memberof CreateTenantRelationshipRequest
     */
    targetTenantId: string;
    /**
     * Justification for the relationship request
     * @type {string}
     * @memberof CreateTenantRelationshipRequest
     */
    justification: string;
    /**
     * When the relationship should expire
     * @type {Date}
     * @memberof CreateTenantRelationshipRequest
     */
    expiresAt?: Date;
    /**
     * Whether the relationship requires periodic reapproval
     * @type {boolean}
     * @memberof CreateTenantRelationshipRequest
     */
    requiresReapproval?: boolean;
    /**
     * When the relationship needs next reapproval (if requiresReapproval is true)
     * @type {Date}
     * @memberof CreateTenantRelationshipRequest
     */
    nextReapprovalAt?: Date;
}

/**
 * Check if a given object implements the CreateTenantRelationshipRequest interface.
 */
export function instanceOfCreateTenantRelationshipRequest(value: object): value is CreateTenantRelationshipRequest {
    if (!('targetTenantId' in value) || value['targetTenantId'] === undefined) return false;
    if (!('justification' in value) || value['justification'] === undefined) return false;
    return true;
}

export function CreateTenantRelationshipRequestFromJSON(json: any): CreateTenantRelationshipRequest {
    return CreateTenantRelationshipRequestFromJSONTyped(json, false);
}

export function CreateTenantRelationshipRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTenantRelationshipRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'targetTenantId': json['targetTenantId'],
        'justification': json['justification'],
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
        'requiresReapproval': json['requiresReapproval'] == null ? undefined : json['requiresReapproval'],
        'nextReapprovalAt': json['nextReapprovalAt'] == null ? undefined : (new Date(json['nextReapprovalAt'])),
    };
}

export function CreateTenantRelationshipRequestToJSON(json: any): CreateTenantRelationshipRequest {
    return CreateTenantRelationshipRequestToJSONTyped(json, false);
}

export function CreateTenantRelationshipRequestToJSONTyped(value?: CreateTenantRelationshipRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'targetTenantId': value['targetTenantId'],
        'justification': value['justification'],
        'expiresAt': value['expiresAt'] == null ? undefined : ((value['expiresAt']).toISOString()),
        'requiresReapproval': value['requiresReapproval'],
        'nextReapprovalAt': value['nextReapprovalAt'] == null ? undefined : ((value['nextReapprovalAt']).toISOString()),
    };
}

